module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NoteList"
  }, [_c('div', {
    staticClass: "topBar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "searchBar"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWord),
      expression: "searchWord"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "search the notes"
    },
    domProps: {
      "value": (_vm.searchWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWord = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tag),
      expression: "tag"
    }],
    staticClass: "tagSelect",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tag = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((Array.from(_vm.tags)), function(tag) {
    return _c('option', [_vm._v(_vm._s(tag))])
  })), _c('button', {
    staticClass: "addNote",
    on: {
      "click": _vm.createNote
    }
  }, [_vm._v("Add Note")])])]), _c('div', {
    staticClass: "items"
  }, [_c('ul', _vm._l((_vm.notesFiltered), function(note, index) {
    return _c('li', [_c('NoteListItems', {
      attrs: {
        "note": note
      }
    })], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15e3bec2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteList.vue
// module id = 222
// module chunks = 1